function swish() {
  var module = $(".module-swish");

  if (module.length) {
    var currentAmount = module.attr("data-value");

    if (currentAmount) {
      currentAmount = parseInt(currentAmount);
      var oldUrl = $("#swishTotalAmountButton").attr("data-href");
      var newUrl = oldUrl + "&alg_open_price=" + currentAmount;

      if ($("#agency").length) {
        const agency = $("#agency").val();

        newUrl = newUrl + "&agency=" + agency;
      }

      $("#swishTotalAmountButton").attr("href", newUrl);
      $("#swishTotalAmountButton").attr("data-alg_open_price", currentAmount);

      if (currentAmount == 0) {
        $("#swishTotalAmountButton").prop("disabled", true);
      } else {
        $("#swishTotalAmountButton").prop("disabled", false);
      }
    }
  }

  $("#swish-amount").on("keyup change", function () {
    var currentAmount = parseInt($("#swish-amount").val());
    var oldUrl = $("#swishTotalAmountButton").attr("data-href");
    var newUrl = oldUrl + "&alg_open_price=" + currentAmount;

    if ($("#agency").length) {
      const agency = $("#agency").val();

      newUrl = newUrl + "&agency=" + agency;
    }

    $("#swishTotalAmountButton").attr("href", newUrl);
    $("#swishTotalAmountButton").attr("data-alg_open_price", currentAmount);

    if (currentAmount == 0) {
      $("#swishTotalAmountButton").prop("disabled", true);
    } else {
      $("#swishTotalAmountButton").prop("disabled", false);
    }
  });
}
export default swish;
